import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import styles from './CustomCheckbox.css';


const CustomCheckbox = (props) => {
  const {
    checkboxClass,
    className,
    label,
    labelClass,
    ...rest
  } = props;

  const classes = {
    root: className,
    label: labelClass,
  };
  const checkboxClasses = {
    root: checkboxClass,
    checked: styles.checked,
  };

  const control = (
    <Checkbox
      classes={checkboxClasses}
      color="default"
      {...rest}
    />
  );

  return (
    <FormControlLabel
      classes={classes}
      control={control}
      label={label}
    />
  );
};

CustomCheckbox.propTypes = {
  checkboxClass: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelClass: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

CustomCheckbox.defaultProps = {
  checkboxClass: undefined,
  className: undefined,
  label: undefined,
  labelClass: undefined,
  value: undefined,
  onChange: undefined,
};

export default CustomCheckbox;
